import styled from '@emotion/styled';
import { Modal } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

const modalBodyFontSize = '14px';

export const StyledModal = styled(Modal)`
  max-width: 600px;
  width: 600px;
`;

export const StyledHeaderText = styled(Text)`
  font-size: 1rem;
`;

export const StyledBodyText = styled(Text)`
  font-size: ${modalBodyFontSize};
`;

export const StyledListText = styled.li`
  font-size: ${modalBodyFontSize};
  padding: 0 0 16px 10px;
`;

export const StyledOrderList = styled.ol`
  padding: 15px 0 0 20px;
  margin: 0;
`;
